import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Warning = (props) => {
    return (
        <span
            className='flex items-center type-style-7'
            {...props}>
            <svg
                className='flex-none mr-20'
                style={{ width: '24px', height: '24px' }}
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'>
                <g clipPath='url(#clip0_102_1456)'>
                    <path
                        d='M12.0002 0.560059L0.240234 22.6701H23.7602L12.0002 0.560059ZM11.3302 10.0001H12.6802V15.0001H11.3302V10.0001ZM11.3302 17.5001H12.6702V19.0001H11.3302V17.5001Z'
                        fill='black' />
                </g>
                <defs>
                    <clipPath id='clip0_102_1456'>
                        <rect
                            fill='white'
                            height='24'
                            width='24' />
                    </clipPath>
                </defs>
            </svg>

            {props.children}
        </span>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

Warning.propTypes = {
    children: PropTypes.any,
};

export default Warning;
